import { computed, observable, action } from 'mobx';
import { BaseUserStore } from '~/stores/base-user.store';
import { IPaymentMethodResponse } from '~/types/server.types';
import type { GlobalCXContextValue } from '~/components/ClientExperience/providers/global-context/global-cx.context';
import { CXFlowSessionStore } from '~/components/ClientExperience/OneFlow/stores/cx-flow-session.store';

export class CXUserStore extends BaseUserStore {
    // TODO: Need to move this logic into cx-flow.context, It must stay here for now because the general api service is coupled to cx flow session store
    flowSessionStore: CXFlowSessionStore;

    @observable paymentMethods: IPaymentMethodResponse[] = [];
    @observable fetchedPaymentMethods: boolean = false;

    setFlowSessionStore(flowSessionStore: CXFlowSessionStore) {
        this.flowSessionStore = flowSessionStore;
    }

    @computed
    get currUser() {
        // TODO: fix this casting.. I tried defning the rootStore attribute
        // on this class but it caused it to be undefined
        const {
            sessionStore: { currUserId, authenticated }
        } = this.globalContext as GlobalCXContextValue;

        if (this.isWeakAuthentication) {
            return this.flowSessionStore.userWeakAuthData;
        }

        if (!authenticated) {
            return null;
        }

        return this.byId(currUserId);
    }

    @computed
    get isWeakAuthentication() {
        const { sessionStore } = this.globalContext;
        return sessionStore.weakAuthenticated && !sessionStore.authenticated;
    }

    @computed
    get flowPaymentMethods() {
        return this.paymentMethods.filter(pm => !pm.is_mobile_wallet);
    }

    @computed
    get flowPaymentMethodsWithMobileWallet() {
        return this.paymentMethods;
    }

    @action.bound
    setFlowPaymentMethods(paymentMethods: IPaymentMethodResponse[]) {
        this.paymentMethods = paymentMethods;
    }

    @action.bound
    setFetchedPaymentMethods(state: boolean) {
        this.fetchedPaymentMethods = state;
    }

    @action.bound
    addPaymentMethod(paymentMethod: IPaymentMethodResponse) {
        this.paymentMethods.push(paymentMethod);
    }

    @action.bound
    deletePaymentMethod(paymentMethodId: string) {
        this.paymentMethods = this.paymentMethods.filter(
            pm => pm._id !== paymentMethodId
        );
    }

    @action.bound
    getPaymentMethod(id: string) {
        return (this?.paymentMethods || []).find(
            paymentMethod => paymentMethod._id === id
        );
    }
}
